import { render, staticRenderFns } from "./isSelectTemplete.vue?vue&type=template&id=22fc9502"
import script from "./isSelectTemplete.vue?vue&type=script&lang=js"
export * from "./isSelectTemplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports